import React from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';

import { UPLOAD_FILE_CLICKED } from '../../../../data-access/src';

import {
  AssetCardContainer,
  DragAndDropText,
  DropZoneContainer,
  TextContainer,
  TypesOfImagesAndDimensionsText,
  UploadFileText,
  UploadFileTextOrDragDropContainer,
  UploadIcon
} from './styledComponents';

interface AssetUploaderComponentTypes {
  uploadFileFunction?: () => any;
  fileUploaderSend;
  isNotValid: boolean | undefined;
}

export const AssetUploaderComponent = (props: AssetUploaderComponentTypes) => {
  const { t } = useTranslation();
  const { uploadFileFunction, fileUploaderSend, isNotValid } = props;

  const DropZoneWithoutClick = () => {
    const { getRootProps, acceptedFiles, isDragActive } = useDropzone();

    if (acceptedFiles[0]) {
      fileUploaderSend({
        type: UPLOAD_FILE_CLICKED,
        imgDetails: acceptedFiles[0]
      });
    }

    return (
      <DropZoneContainer {...getRootProps({ className: 'dropzone' })}>
        <AssetCardContainer
          onClick={uploadFileFunction}
          isDragActive={isDragActive}
          isNotValid={isNotValid}
        >
          <UploadIcon />
          <TextContainer>
            <UploadFileTextOrDragDropContainer>
              <UploadFileText>{t('common.uploadAFile')}</UploadFileText>
              <DragAndDropText>{t('common.dragAndDrop')}</DragAndDropText>
            </UploadFileTextOrDragDropContainer>
            <TypesOfImagesAndDimensionsText>
              {`PNG,JPG,PDF, upto 5 MB`}
            </TypesOfImagesAndDimensionsText>
          </TextContainer>
        </AssetCardContainer>
      </DropZoneContainer>
    );
  };

  return <DropZoneWithoutClick />;
};
